<template>
  <div style="display: flex;flex-direction: column;width: 100%;">
    <!-- 数据信息 -->
    <div class="order-input-wrap"
     v-if="!['1010698','1010699','1010700','3010130'].includes(orderDetail.servCataId)">

      <base-tag label="数据信息"></base-tag>

      <!-- 扫描仪品牌 -->
      <div class="input-form-wrap">
        <div class="input-label">
          <span>扫描仪品牌：</span>
        </div>
        <div class="input-value">
          <span>
          {{softType}}
          </span>
        </div>
      </div>

    </div>
    <div v-if="orderDetail.servCataId=='3010130'&&fileDataList.dataFaceImg">
      <baseTag label="面像照"></baseTag>
      <div class="pane-download" style="display:inherit;height: 200px;">
        <div class="demo-image__preview" v-for="(item,index) in fileDataList.dataFaceImg" :key="index">
          <el-image
            style="max-width: 120px; height: auto;float: left;margin: 10px;"
            :src="item"
            :preview-src-list="fileDataList.dataFaceImg">
          </el-image>
        </div>
      </div>
    </div>
    <div v-if="orderDetail.servCataId=='3010130'&&fileDataList.dataMouth">
      <baseTag label="口内照"></baseTag>
      <div class="pane-download" style="display:inherit;height: 140px;">
        <div class="demo-image__preview" v-for="(item,index) in fileDataList.dataMouth" :key="index">
          <el-image
            style="max-width: 120px; height: 100px;float: left;margin: 10px;"
            :src="item"
            :preview-src-list="fileDataList.dataMouth">
          </el-image>
        </div>
      </div>
    </div>
    <div v-if="orderDetail.servCataId=='3010130'&&fileDataList.dataVideo">
      <baseTag label="影像资料"></baseTag>
      <div class="pane-download" style="display:inherit;height: 140px;">
        <div class="demo-image__preview" v-for="(item,index) in fileDataList.dataVideo" :key="index">
          <el-image
            style="max-width: 120px; height: 100px;float: left;margin: 10px;"
            :src="item"
            :preview-src-list="fileDataList.dataVideo">
          </el-image>
        </div>
      </div>
    </div>

    <detail-data label="模型数据" :fileList="orderDetail.dataScan" :servOrderId="orderDetail.servOrderId"
      v-if="orderDetail.servCataId=='3010130'" :isDown="isDown">
    </detail-data>

    <detail-data label="扫描数据" :fileList="orderDetail.dataScan" :servOrderId="orderDetail.servOrderId"
      v-if="common.serv.get(orderDetail.servCataId).isScanData === '1'" :isDown="isDown">
    </detail-data>

    <!-- <detail-photo label="设计单照片" :srcList="orderDetail.dataSheet"
      v-if="common.serv.get(orderDetail.servCataId).isSheetData === '1'">
    </detail-photo> -->

    <detail-photo label="口内照片" :srcList="orderDetail.dataMouth" :servOrderId="orderDetail.servOrderId"
      v-if="common.serv.get(orderDetail.servCataId).isMouthData === '1'">
    </detail-photo>

    <detail-data label="CBCT数据" :fileList="orderDetail.dataCbct" :dataSheet="orderDetail.dataSheet" :servOrderId="orderDetail.servOrderId"
      v-if="common.serv.get(orderDetail.servCataId).isCbctData === '1'" :isDown="isDown">
    </detail-data>

    <detail-data :label="['4010110'].includes(orderDetail.servCataId)?'精密配件数据库':'扫描杆和替代体数据库'" :fileList="orderDetail.dataScanRod" :servOrderId="orderDetail.servOrderId"
      v-if="orderDetail.dataScanRod!='[]'&&orderDetail.servCataId!='3010130'" :isDown="isDown">
    </detail-data>

    <detail-data label="精密配件数据库" :fileList="orderDetail.servOrderRpd.dataAccessory" :servOrderId="orderDetail.servOrderId"
      v-if="orderDetail.servCataId=='4010110'&&orderDetail.servOrderRpd.dataAccessory!='[]'&&orderDetail.servOrderRpd.enclosure" :isDown="isDown">
    </detail-data>
  </div>

</template>

<script>
  import DetailData from './components/detailData';
  import DetailPhoto from './components/detailPhoto';
  import Comment from './comment';
  import BaseTag from '/components/BaseTag';
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      orderDetail: {
        type: Object,
        default: null
      },
      isDown: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapState(['common', 'user'])
    },
    data(){
      return{
        softType:'',
        fileDataList:{},
      }
    },
    methods: {
      downloadFile(downUrl) {
        window.open(downUrl)
      },
      softTypeShow(){
        this.common.dict.get('biz_soft_type').forEach(val=>{
          if(val.value == this.orderDetail.softType){
            this.softType = val.label
          }
        })
        if(this.orderDetail.softType == '99'){
          this.softType = this.orderDetail.otherSoftType
        }
      }
    },
    created(){
      this.common.serv.get('3010130').isFaceImg === 1
      this.common.serv.get('3010130').isOralCavity === 1
      this.common.serv.get('3010130').isSliceImage === 1
      this.common.serv.get('3010130').isModel === 1
      this.common.serv.get('3010130').isOralCavity === 1
      this.fileDataList.dataMouth = this.orderDetail.dataMouth?JSON.parse(this.orderDetail.dataMouth):[];
      this.fileDataList.dataVideo = this.orderDetail.orthodonticsData.dataVideo?JSON.parse(this.orderDetail.orthodonticsData.dataVideo):[];
      this.fileDataList.dataFaceImg = this.orderDetail.orthodonticsData.dataFaceImg?JSON.parse(this.orderDetail.orthodonticsData.dataFaceImg):[];
    },
    mounted() {
      this.softTypeShow()
    },
    components: {
      DetailData,
      DetailPhoto,
      Comment,
      BaseTag,
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";
  .input-form-wrap{
    width: 33%;
    padding: 7px 10px;
    display: flex;
    float: left;
    .input-label{
      width: 140px;
      margin-left: 2%;
    }

    /deep/ .input-value {
        width: 180px;
        flex: 0 1 auto;
        padding: 2px 10px;
        border-radius: 4px;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        background-color: #ececec;
      }
  }
</style>



// WEBPACK FOOTER //
// detailDown.vue?55c5c8d0